import React from 'react';


const date = new Date();
const now = date.getFullYear();
const Footer = () => {
    return ( 
        <div className="footer">
            <p>&copy; {now} Powered by <a href={"https://www.food2fork.com"} target="-blank" className="footer-link">food2fork</a></p>
        </div>
    );
}
 
export default Footer;